import {Trans} from "react-i18next";

export const DataNotFound = () => {
  return (
    <div>
      <Trans>Data not found</Trans>
    </div>
  );
};
